import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {IE3Address} from "@portbase/bezoekschip-service-typescriptmodels";
import {add} from "lodash";
import {PortvisitUtils} from "../portvisit-utils";

@Component({
    selector: 'app-edit-address',
    templateUrl: './edit-address.component.html',
    styleUrls: ['./edit-address.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditAddressComponent {
  @Input() address: IE3Address;
  @Input() editable: boolean;
  @Output() addressChange: EventEmitter<IE3Address> = new EventEmitter<IE3Address>();

  protected readonly add = add;
  protected readonly portVisitUtils = PortvisitUtils;
}
